var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLatvia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 12H31V20H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5,4H27c2.208,0,4,1.792,4,4v5H1v-5c0-2.208,1.792-4,4-4Z",
    fill: "#922a35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5,19H27c2.208,0,4,1.792,4,4v5H1v-5c0-2.208,1.792-4,4-4Z",
    transform: "rotate(180 16 23.5)",
    fill: "#922a35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z",
    opacity: 0.15
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z",
    fill: "#fff",
    opacity: 0.2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLatvia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Latvia.b215bcfca27edcc8204697cc12b0f9d3.svg";